// extracted by mini-css-extract-plugin
export default {"imageCard":"FeaturePreviewCard-module__imageCard--aqK5M","img":"FeaturePreviewCard-module__img--iJosl"};